@if (customFieldsForm) {
    <form [formGroup]="customFieldsForm" nz-form>
        <div
            class="pf-form-group"
            [ngClass]="{ compact: pfStyle === 'block', column: pfColumn }">
            <ng-content></ng-content>
            @for (
                customFieldConfig of processedCustomFieldConfigs;
                track trackByFn($index, customFieldConfig)
            ) {
                @if (
                    customFieldConfig.list &&
                    customFieldLists[customFieldConfig.key]?.input
                ) {
                    <platform-custom-field-list
                        [customFieldKey]="customFieldConfig.key"
                        [showSearch]="false"
                        [inputType]="customFieldConfig.listInputType || 'text'"
                        [options]="customFieldConfig.listOptions || []"
                        [grouped]="
                            customFieldConfig.listOptionsGrouped || false
                        "
                        [listLabel]="customFieldConfig.label || ''"
                        [listHeaders]="customFieldConfig.listHeaders || []"
                        [multiTextAutoCompleteOptions]="
                            customFieldConfig.multiTextAutoCompleteOptions
                        "
                        [listItemLimit]="customFieldConfig.listItemLimit"
                        [customFields]="
                            customFieldLists[customFieldConfig.key].input
                                | safeArray
                        "
                        [tooltip]="customFieldConfig.tooltip"
                        (itemsChanged)="
                            listItemsChanged($event, customFieldConfig.key)
                        "></platform-custom-field-list>
                }
                @if (!customFieldConfig.list) {
                    <pf-dynamic-control
                        [config]="customFieldConfig"
                        [pfStyle]="pfStyle"
                        [formControlName]="
                            customFieldConfig.key
                        "></pf-dynamic-control>
                }
            }
            @if (processedCustomFieldConfigs.length % 2) {
                <div></div>
            }
        </div>
    </form>
}
